// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"e03d6e26","787":"669a778b"}[chunkId] + ".chunk.js";
};